// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"68ca522f","453":"2454016c"}[chunkId] + ".chunk.js";
};